/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import { LuiInputBase } from '@here/lui-base'
import scopedCss from 'lui-step.scss'
import template from 'lui-step.html'

export default class LuiStep extends LuiInputBase {
  static get is() {
    return 'lui-step'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  static get clickTriggers() {
    return ['space', 'enter']
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  init() {
    super.init()
    this._onClickBound = this._onClickBound || ((event) => this._onClick(event))
    this.seedElement.addEventListener('click', this._onClickBound)

    if (this.selected || this.disabled) {
      this.seedElement.classList.remove('lui-interactive')
    }

    if (this.disabled) {
      this.seedElement.classList.add('lui-disabled')
    }

    this.selectedChanged()
  }

  onDisconnected() {
    super.onDisconnected()
    this.seedElement.removeEventListener('click', this._onClickBound)
  }

  selectedChanged() {
    if (this.hasAttribute('selected')) {
      this.removeAttribute('tabindex')
      this.removeEventListener('focus', this._onFocus)
      this.removeEventListener('blur', this._onBlur)
    } else if (!this.hasAttribute('disabled')) {
      this.setAttribute('tabindex', 0)
      this.addEventListener('focus', this._onFocus)
      this.addEventListener('blur', this._onBlur)
    }
  }

  _getField() {
    return this.seedElement
  }

  _onClick(event) {
    if (!this.hasAttribute('selected') && !this.hasAttribute('disabled')) {
      this.selected = true
      this.seedElement.classList.remove('lui-interactive')
      this.dispatchEvent(new Event('change', {bubbles: true}))
    }
  }

  get selected() {
    return this.hasAttribute('selected')
  }

  set selected(value) {
    if (value) {
      this.setAttribute('selected', '')
    } else {
      this.removeAttribute('selected')
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-stepper/lui-step.js
// module id = 332
// module chunks = 0 1 7